
/* START_TEMPLATE */
define('hbs!app/views/templates/golferNamesForm',['hbs','Handlebars','app/views/templates/helpers/forHbs'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  <input type=\"radio\" id="
    + this.escapeExpression(this.lambda((depth0 != null ? depth0.ItemId : depth0), depth0))
    + " name=\"rate\" value="
    + this.escapeExpression(this.lambda((depth0 != null ? depth0.ItemId : depth0), depth0))
    + ">\r\n  <label for="
    + this.escapeExpression(this.lambda((depth0 != null ? depth0.ItemId : depth0), depth0))
    + "> <strong>$"
    + this.escapeExpression(this.lambda((depth0 != null ? depth0.Price : depth0), depth0))
    + "-</strong>"
    + this.escapeExpression(this.lambda((depth0 != null ? depth0.ItemName : depth0), depth0))
    + "</label>\r\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <h5>"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.golf : stack1)) != null ? stack1.modal : stack1)) != null ? stack1.playerNames : stack1), depth0))
    + "</h5>\r\n      <div class=\"players\">\r\n"
    + ((stack1 = (helpers.forHbs || (depth0 && depth0.forHbs) || helpers.helperMissing).call(depth0,1,4,1,{"name":"forHbs","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      </div>\r\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return "          <div class=\"player\">\r\n            <label for=\"playerName"
    + this.escapeExpression(this.lambda(depth0, depth0))
    + "\">"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = ((stack1 = ((stack1 = (data && data.root)) && stack1.Localization)) && stack1.golf)) && stack1.modal)) && stack1.playerNum), depth0))
    + " "
    + this.escapeExpression(this.lambda(depth0, depth0))
    + ":</label>\r\n            <input type=\"text\" name=\"Player-["
    + this.escapeExpression(this.lambda(depth0, depth0))
    + "]\" id=\"playerName"
    + this.escapeExpression(this.lambda(depth0, depth0))
    + "\" placeholder=\""
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.golf : stack1)) != null ? stack1.modal : stack1)) != null ? stack1.playerName : stack1), depth0))
    + "\" disabled>          \r\n          </div>\r\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return "      <h5>"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.golf : stack1)) != null ? stack1.modal : stack1)) != null ? stack1.additionalNotes : stack1), depth0))
    + "</h5>\r\n      <div class=\"player\">\r\n        <label for=\"generalNote\">"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.golf : stack1)) != null ? stack1.modal : stack1)) != null ? stack1.noteLabel : stack1), depth0))
    + "</label>\r\n        <input type=\"text\" name="
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.golf : stack1)) != null ? stack1.modal : stack1)) != null ? stack1.noteName : stack1), depth0))
    + " id=\"generalNote\" placeholder="
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.golf : stack1)) != null ? stack1.modal : stack1)) != null ? stack1.notePlaceHolder : stack1), depth0))
    + ">\r\n      </div>\r\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div id=\"golferInformationForm\" action=\"\" method=\"post\">\r\n  <h4> <strong>"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.golf : stack1)) != null ? stack1.modal : stack1)) != null ? stack1.heading : stack1), depth0))
    + "</strong></h4>\r\n  <h5>"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.golf : stack1)) != null ? stack1.modal : stack1)) != null ? stack1.rateType : stack1), depth0))
    + "</h5>\r\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.GolfRates : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  <br>\r\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.Customization : depth0)) != null ? stack1.golfBooking : stack1)) != null ? stack1.enableGolfModalPlayerNames : stack1),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "   \r\n"
    + ((stack1 = helpers['if'].call(depth0,((stack1 = ((stack1 = (depth0 != null ? depth0.Customization : depth0)) != null ? stack1.golfBooking : stack1)) != null ? stack1.enableGolfModalGeneralNote : stack1),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  <input type=\"submit\" style=\"visibility: hidden;\" />\r\n</form>";
},"useData":true});
Handlebars.registerPartial('app/views/templates/golferNamesForm', t);
Handlebars.registerPartial('app/views/templates/golferNamesForm', t);
return t;
});
/* END_TEMPLATE */
;
